import { Rule } from 'antd/es/form'
import { QuestionnaireItem } from '@medplum/fhirtypes'
import { Dayjs } from 'dayjs'

export enum QuestionLayout {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export enum AnswersLayout {
  HORIZONTAL = 'row',
  COLUMN = 'column'
}

export interface SelectOption {
  label?: string
  value: string | number
  disabled?: boolean
}

// Base props common to all question types
export interface BaseQuestionProps {
  field: QuestionnaireItem
  formFieldName: string
  layout: QuestionLayout
  disabled?: boolean
  required?: boolean
  customRules?: Rule[]
}

export interface TextAreaQuestionProps extends BaseQuestionProps {
  placeholder?: string
  rows?: number
  disabledResize?: boolean
  allowClear?: boolean
}

export interface SelectQuestionProps extends BaseQuestionProps {
  placeholder?: string
  customOptions?: SelectOption[]
  loading?: boolean
  onChange?: (value: string) => void
  showSearch?: boolean
  allowClear?: boolean
}

export interface MultiSelectQuestionProps extends BaseQuestionProps {
  placeholder?: string
  customOptions?: SelectOption[]
  loading?: boolean
}

export interface RadioQuestionProps extends BaseQuestionProps {
  customOptions?: SelectOption[]
  answersLayout?: AnswersLayout
}

export interface InputQuestionProps extends BaseQuestionProps {
  placeholder?: string
  type?: 'text' | 'password' | 'email' | 'url' | 'number' | 'tel' | 'search'
  allowClear?: boolean
}

export interface NumberQuestionProps extends BaseQuestionProps {
  placeholder?: string
  min?: number
  max?: number
  step?: number
  precision?: number
  formatter?: (value: number | string | undefined) => string
  parser?: (displayValue: string | undefined) => number | string
  addonAfter?: string | React.ReactNode
  addonBefore?: string | React.ReactNode
}

export interface DatePickerQuestionProps extends BaseQuestionProps {
  placeholder?: string
  format?: string
  showTime?: boolean | { format?: string }
  picker?: 'date' | 'week' | 'month' | 'quarter' | 'year'
  allowClear?: boolean
}

export interface CaregiverDatePickerQuestionProps extends BaseQuestionProps {
  placeholder?: string
  format?: string
  showTime?: boolean
  timezone: string
}

export interface CaregiverTimePickerQuestionProps extends BaseQuestionProps {
  placeholder?: string
  timezone: string
  minuteStep?: number
  customSecondaryText?: string
}

export interface CaregiverDateRangePickerQuestionProps extends BaseQuestionProps {
  format?: string
  showTime?: boolean | { format?: string }
  timezone: string
}

export enum DiagnosisKeys {
  DIAGNOSIS = 'diagnosis',
  RATING = 'rating',
  DATE = 'date'
}

export interface Diagnosis {
  [DiagnosisKeys.DIAGNOSIS]: string
  [DiagnosisKeys.RATING]: string
  [DiagnosisKeys.DATE]: [Dayjs?, Dayjs?]
}
